import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const INSTAGRAM_URL = 'https://www.instagram.com/na.lilu';
const images = ['https://cdn.magicpatterns.com/uploads/wukPzrmimUooozenx3Ng1W/photo_5301161740299082105_y.jpg', 'https://cdn.magicpatterns.com/uploads/srnnnzfhLVyKMEsG427we1/photo_5301161740299082098_y.jpg', 'https://cdn.magicpatterns.com/uploads/3RHZLnZixFT9q1yYBx9BcA/photo_5301161740299082089_y.jpg', 'https://cdn.magicpatterns.com/uploads/8uMawBaPh3jYfskiYnQ2CF/photo_5301161740299082106_x.jpg', 'https://cdn.magicpatterns.com/uploads/pZoVMPpgbt8eaaMVMQbv5n/photo_5301161740299082084_y.jpg', 'https://cdn.magicpatterns.com/uploads/aJ1VNaukSeUvgoCqRSMMt5/photo_5301161740299082091_y.jpg'];
export function InstagramGallery() {
  return <section className="py-24 bg-brand-cream" data-id="element-271" data-mp="tlwm6js8kwl0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272" data-mp="tkl89r52u8g6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-273" data-mp="oo4iytm55o1i">
          <div data-id="element-274" data-mp="3igob2jvg09yb">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-275" data-mp="3if3gwvd1it0z">
              Приєднуйтесь до нашої спільноти
            </h2>
            <p className="text-brand-dark/70" data-id="element-276" data-mp="3nhcbtx9h455q">
              Слідкуйте за нами в Instagram для щоденного натхнення та новинок.
            </p>
          </div>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hidden md:flex items-center gap-2 text-brand-burgundy font-medium hover:text-brand-burgundy/80 transition-colors" data-id="element-277" data-mp="9ifke0ew2sn">
            <Instagram className="w-5 h-5" data-id="element-278" data-mp="38qd4sqoadoo9" />
            @na.lilu
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-279" data-mp="3dh1x287sipog">
          {images.map((img, index) => <motion.a key={index} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="group relative aspect-square overflow-hidden rounded-xl block" data-id="element-280" data-mp="2gzp8pt1gz9hg" data-mpi={index}>
              <img src={img} alt="Публікація в Instagram" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-281" data-mp="35dca2naagdjl" />
              <div className="absolute inset-0 bg-brand-dark/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-282" data-mp="3ebe6epj2ui0j">
                <Instagram className="w-8 h-8 text-white" data-id="element-283" data-mp="tm893s443ilc" />
              </div>
            </motion.a>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-284" data-mp="pleqne9fuvzu">
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-burgundy font-medium" data-id="element-285" data-mp="x4xp8sv60xtj">
            <Instagram className="w-5 h-5" data-id="element-286" data-mp="n82ric6pv1gb" />
            Стежити за @na.lilu
          </a>
        </div>
      </div>
    </section>;
}